import * as React from 'react'

import useI18n from '@store/i18n/useI18n'
import * as AuthStore from '@store/auth/auth'
import styled from '@theme/styled-components'

import Button from '@components/button/button'
import apis from '@api/api'

interface Props {
  closeModal: () => void
  cgus?: string
}

const Cgus = ({ closeModal, cgus }: Props) => {
  const i18n = useI18n()
  const acceptCgus = () =>
    apis.user.acceptCgus().then(() => {
      closeModal()
      AuthStore.actions.acceptCgus()
      window.location.reload()
    })

  return (
    <Container>
      <InformationContainer>
        <InformationTitle>{i18n.t('components.cgus.title')}</InformationTitle>
        <InformationLibelle>{cgus}</InformationLibelle>
      </InformationContainer>
      <ButtonContainer>
        <Button
          title={i18n.t('components.cgus.accept')}
          status="active"
          type="classic"
          size="medium"
          onClick={acceptCgus}
        />
      </ButtonContainer>
    </Container>
  )
}

export default Cgus

const Container = styled('div')`
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  top: 0px;
  min-height: 100px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  border-radius: 50px;
  padding: 50px;
  margin: 50px;
  background: ${(props) =>
    `linear-gradient(
    50deg,
    ${props.theme.colors.navigationButton01} 0%,
    ${props.theme.colors.navigationButton02} 100%
  )`};
`
const InformationContainer = styled('div')`
  margin-bottom: 25px;
`
const InformationLibelle = styled('div')`
  ${(props) => props.theme.fonts.label};
  text-align: justify;
  color: white;
  max-height: calc(100vh - 332px);
  flex: 1;
  overflow: hidden;
  overflow-y: scroll;
`
const InformationTitle = styled('h2')`
  ${(props) => props.theme.fonts.title};
  color: ${(props) => props.theme.colors.secondary_text};
`

const ButtonContainer = styled('div')`
  display: flex;
  position: absolute;
  bottom: 50px;
  right: 50px;
`
